import { render, staticRenderFns } from "./ThemeSelector.vue?vue&type=template&id=736c295d&scoped=true&"
import script from "./ThemeSelector.vue?vue&type=script&lang=js&"
export * from "./ThemeSelector.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSelector.vue?vue&type=style&index=0&id=736c295d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736c295d",
  null
  
)

export default component.exports